// extracted by mini-css-extract-plugin
export default {"root":"Link_root__3zyGI","light":"Link_light__1XCoT","small":"Link_small__2KUXW","medium":"Link_medium__15QG_","large":"Link_large__1YiJK","underline":"Link_underline__1CX7J"};